import { render, staticRenderFns } from "./ai-nav.vue?vue&type=template&id=589dd632&scoped=true&"
import script from "./ai-nav.vue?vue&type=script&lang=js&"
export * from "./ai-nav.vue?vue&type=script&lang=js&"
import style0 from "./ai-nav.vue?vue&type=style&index=0&id=589dd632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589dd632",
  null
  
)

export default component.exports